// @ts-check
import Vue from 'vue';

/**
 * @typedef {ReturnType<typeof getDefaultState>['modalContent']} ModalContent 
 */

function getDefaultState() {
  return {
    isOpen: false,
    modalContent: {
      /**
       * Modal title
       * @type {string} 
       */
      title: '',
      /**
       * Optional Modal title
       * @type {string | null} 
       */
      message: '',
      /**
       * Optional Modal classes
       * @type {string | null}
       */
      modalClass: '',
      /**
       * Optional modal component name
       * @type {string | null} 
       */
      contentComponent: '',
      /**
       * Optional modal component props
       * @type {any} 
       */
      contentCompomentProps: {},
      /**
       * Optional modal footer callback function
       * @type {Function | null} 
       */
      footerCb: null,
      /**
       * Optional modal component footer button label
       * @type {string | null} 
       */
      footerBtnLabel: '',
    },
  };
}

/**
 * Open modal with given modal content
 * @param {Partial<ModalContent>} modalContent 
 */
export function openModal(modalContent) {
  Object.assign(modalStore, {
    isOpen: true,
    modalContent,
  });
}

/**
 * Close modal
 */
export function closeModal() {
  Object.assign(modalStore, getDefaultState());
}

export const modalStore = Vue.observable(getDefaultState());
